import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerRelatedItemsConverter extends CmsConverterService<ColorContainerRelatedItemsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      icon: formData.st_icon?.value?.identifier ?? '',
      links: formData.st_related_items ?? defaultFSCatalog
    }
  }
}

export const COLOR_CONTAINER_RELATED_ITEMS_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColorContainerRelatedItemsData>>('RelatedItemsConverter')

export interface ColorContainerRelatedItemsData extends ConvertedComponentData {
  headline: TextInput;
  icon: string;
  links: FsCatalog;
}
